/**
 * GlobalUnhandleAngularErrorLogService
 *
 * This service implements Angular's ErrorHandler interface to capture and log all uncaught errors
 * within the Angular zone. It uses CustomLoggerService to record these errors for diagnostics.
 *
 * Usage:
 *   - Provide this service as the ErrorHandler in your app module or component providers.
 *   - All uncaught errors in Angular will be logged automatically.
 *
 * This helps in tracking and diagnosing unexpected Angular errors in production apps.
 */
import { ErrorHandler, Injectable } from '@angular/core';
import { CustomLoggerService } from '@monorepo/services';

@Injectable()
export class GlobalUnhandleAngularErrorLogService implements ErrorHandler {
  constructor(private customLoggerService: CustomLoggerService) {}

  handleError(error: Error | unknown): void {
    const errorObj = error instanceof Error ? error : new Error(String(error));
    this.customLoggerService.logUnhandledError(errorObj.message, errorObj.stack, {
      source: 'angular.errorHandler',
    });
  }
}
